import { FAILED_TO_LOAD_TRANSLATION } from "context/AppContext"
import { useAppErrorDataContext } from "context/AppErrorContext"
import getConfig from "next/config"

function LostConnection() {
    
    const { global_error } = useAppErrorDataContext()
    const { NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

    if (global_error.message == FAILED_TO_LOAD_TRANSLATION) {
        return (
            <div className="flex flex-col justify-center items-center w-full h-screen gap-6">
                <div
                    className="h-24 w-56 bg-center bg-no-repeat mx-auto mb-12"
                    style={{
                        backgroundImage:
                            `url(//${NEXT_PUBLIC_STATIC_DOMAIN}/images/NoConnection.svg) no-repeat`,
                    }}
                />
    
                <p className="text-center max-w-lg">
                    Uh oh! Something has gone wrong.
                    <br />
                    You may have lost your connection or encountered an error.
                    Please try again.
                </p>
    
                <button
                    type="button"
                    className="border border-gray-200 rounded-lg w-56 h-12"
                    onClick={() => {
                        location.reload()
                    }}
                >
                    Refresh
                </button>
            </div>
        )
    }

    return <></>
    
}

export default LostConnection